import { render } from "./EditClaimProposalsModal.vue?vue&type=template&id=89ca7612&scoped=true"
import script from "./EditClaimProposalsModal.vue?vue&type=script&lang=js"
export * from "./EditClaimProposalsModal.vue?vue&type=script&lang=js"

import "./EditClaimProposalsModal.vue?vue&type=style&index=0&id=89ca7612&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ca7612"]])

export default __exports__